import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';

import App from './App';
import FrontBandHandle from './games-app/FrontBandHandle';
import FixOneMove from './games-app/FixOneMove';
import { HomeSample } from './types/CorrectionModel';
import { analytics } from './utils/analytics';
import { clientLog } from './utils/clientLog';

// Ship uncaught errors / unhandled rejections to the server log (→ Seq) from first paint.
clientLog.install();

const domNode = document.getElementById('app');
if (domNode != null) {
  createRoot(domNode).render(
    <Provider store={store}>
      <App />
    </Provider>,
  );
}

// The signed-out home band's handle box is server-rendered outside #app; swap in the shared combobox
// so it offers the same saved names as the filter.
const bandInput = document.getElementById('sc-front-band-handle') as HTMLInputElement | null;
if (bandInput != null) {
  const host = document.createElement('div');
  host.className = 'sc-front-band-handle';
  bandInput.replaceWith(host);
  createRoot(host).render(
    <FrontBandHandle
      id={bandInput.id}
      name={bandInput.name}
      placeholder={bandInput.placeholder}
      initial={bandInput.value}
      authenticated={document.body.dataset.authenticated === 'true'}
    />,
  );
}

// The home page trainer (FixOneMove): your own mistakes when signed in, otherwise strong players'
// blunders. Fetched client-side so the page never waits; the fallback band in Pages/Index.cshtml
// starts hidden and only shows if nothing comes back.
const fixHost = document.getElementById('sc-fix-one');
if (fixHost != null) {
  const authenticated = document.body.dataset.authenticated === 'true';
  const load = (url: string) =>
    fetch(url)
      .then((r) => (r.ok ? (r.json() as Promise<HomeSample[]>) : []))
      .catch(() => [] as HomeSample[]);
  (async () => {
    const mine = authenticated ? await load('/api/Corrections/mine') : [];
    const samples = mine.length > 0 ? mine : await load('/api/Corrections/samples');
    const home = fixHost.closest('.sc-home');
    home?.classList.remove('is-waiting');
    if (samples.length === 0) return;
    home?.classList.add('has-sample');
    createRoot(fixHost).render(
      <FixOneMove initial={samples} mine={mine.length > 0} authenticated={authenticated} />,
    );
    analytics.track('home_fix_shown', { mine: mine.length > 0 ? 'yes' : 'no' });
  })();
}
